<!--
 * @Author: WGL 958897276@qq.com
 * @Date: 2025-05-23 14:48:46
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-08-18 15:09:52
 * @FilePath: /erp-admin/src/components/StagePipelineItem/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-scrollbar>
    <div class="fx">
      <VueDraggable
        v-model="taskGroupList"
        animation="150"
        class="fx"
        :disabled="!isEdit"
        ghost-class="ghost"
      >
        <StagePipelineItem
          v-for="(item, index) in taskGroupList"
          :key="index"
          :index="index"
          :is-edit="isEdit"
          :is-instance="isInstance"
          :item="item"
          :len="len"
          @add-pipeline="handleAddPipeline"
          @change-priority="handleChangePriority"
        >
          <template #title="{ row }">
            <slot name="title" :row="row"></slot>
          </template>
        </StagePipelineItem>
      </VueDraggable>
    </div>
  </el-scrollbar>
</template>

<script setup>
  import {
    defineProps,
    defineEmits,
    ref,
    watchEffect,
    computed,
    defineExpose,
  } from 'vue'
  import { t } from '@/utils/i18n'
  import { isNumber } from 'lodash-es'
  import StagePipelineItem from './components/StagePipelineItem.vue'
  import { VueDraggable } from 'vue-draggable-plus'

  const props = defineProps({
    list: { type: Array, default: () => [] },
    isEdit: { type: Boolean, default: false },
    info: { type: Object, default: () => {} },
    pidKey: { type: String, default: 'id' },
    isInstance: { type: Boolean, default: false }, // 是否是流程实例
  })
  const emit = defineEmits(['add-pipeline'])
  const taskGroupList = ref([])
  const len = computed(() => taskGroupList.value?.length)
  // 添加流水线
  function handleAddPipeline(type, item, index, groupIndex) {
    if (type === 'right') {
      taskGroupList.value.splice(index + 1, 0, {
        title: t('流程名称'),
        priority: 1,
        groupList: [],
      })
    } else if (type === 'bottom') {
      taskGroupList.value[index].groupList.push({
        title: t('流程名称'),
        priority: 1,
      })
    } else if (type === 'delete') {
      if (!props?.isInstance || (props?.isInstance && !item.id)) {
        if (isNumber(groupIndex)) {
          taskGroupList.value[groupIndex].groupList.splice(index - 1, 1)
        } else {
          taskGroupList.value.splice(index, 1)
        }
      }
    }
    emit('add-pipeline', type, item, index, groupIndex)
  }

  function handleChangePriority(val, index, groupIndex) {
    if (isNumber(groupIndex)) {
      taskGroupList.value[groupIndex].groupList[index - 1] = {
        ...taskGroupList.value[groupIndex].groupList[index - 1],
        priority: val,
      }
    } else {
      taskGroupList.value[index].priority = val
    }
  }
  /**
   * 获取列表
   */
  function handleGroupList() {
    const result = []
    taskGroupList.value.forEach((item, index) => {
      result.push({
        title: item.title,
        priority: item.priority,
        stage: index + 1,
        rank: 1,
        [props.pidKey]: props?.info?.id || '',
      })
      item.groupList.forEach((v, i) => {
        result.push({
          title: v.title,
          priority: v.priority,
          stage: index + 1,
          rank: i + 2,
          [props.pidKey]: props?.info?.id || '',
        })
      })
    })
    return result
  }
  /**
   * 获取列表
   */
  function handleGroupArrList() {
    const result = []
    taskGroupList.value.forEach((item, index) => {
      const group = []
      group.push({
        title: item.title,
        priority: item.priority,
        stage: index + 1,
        rank: 1,
        id: item?.id || '',
      })
      item?.groupList?.forEach((v, i) => {
        group.push({
          title: v.title,
          priority: v.priority,
          stage: index + 1,
          rank: i + 2,
          id: v?.id || '',
        })
      })
      result.push(group)
    })
    return result
  }
  watchEffect(() => {
    taskGroupList.value = props.list
  })
  defineExpose({
    handleGroupList,
    handleGroupArrList,
  })
</script>
<script>
  export default {
    name: 'StagePipeline',
  }
</script>
